const EMBEDDED_PATH_PREFIXES = ["/widget", "/reservar/"];

function isEmbeddedPath(pathname: string): boolean {
  return EMBEDDED_PATH_PREFIXES.some((prefix) =>
    prefix.endsWith("/")
      ? pathname.startsWith(prefix)
      : pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

function isFramed(win: Window): boolean {
  try {
    return win.self !== win.top;
  } catch {
    return true;
  }
}

export function isEmbeddedSurface(win: Window = window): boolean {
  return isEmbeddedPath(win.location.pathname) || isFramed(win);
}
